import IExperimentContextProps from "../../Experiment/Types/IExperimentContextProps";
import IFlowResolver, { IFlowAssignment } from "./IFlowResolver";

/**
 * An {@link IFlowResolver} which delegates to the configured resolver only when the patient is pre-qualified.
 * Throws otherwise, allowing a {@link FailoverFlowResolver} to continue to the next resolver.
 */
class PatientQualificationFlowResolver implements IFlowResolver {
  private readonly _isPreQualified: boolean;
  private readonly _delegate: IFlowResolver;

  /**
   * @param isPreQualified - Whether the patient is pre-qualified.
   * @param delegate - The resolver to delegate to when the patient is pre-qualified.
   */
  constructor(isPreQualified: boolean, delegate: IFlowResolver) {
    this._isPreQualified = isPreQualified;
    this._delegate = delegate;
  }

  readonly invoke = (experimentContext: IExperimentContextProps, sessionFlowName: string): IFlowAssignment => {
    if (!this._isPreQualified) throw new Error(PatientQualificationFlowResolver.Messages.patientNotPreQualified);
    return this._delegate.invoke(experimentContext, sessionFlowName);
  };

  static readonly Messages = {
    patientNotPreQualified: "Patient is not pre-qualified."
  };
}

export default PatientQualificationFlowResolver;
